import React from 'react';
import {
	Button,
	Attachment,
	TextArea,
	Checkbox,
	Select,
	Slider,
	DragDrop
} from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';

import Download from '../../../../../assets/Download';

import Styles from './index.module.scss';

enum TabType {
	file = 'file',
	copypaste = 'copypaste'
}

export type DispatchPropsType = {
	onClose: () => void;
};

const Import: React.FC<DispatchPropsType> = ({ onClose }) => {
	const { t } = useTranslation();
	const [currentTab, setTab] = React.useState<string>(TabType.file);

	const getBody = () => {
		if (currentTab === 'file') {
			return (
				<div className={Styles.fileContainer}>
					<DragDrop onChange={console.log} />
					{/* url should be configured. */}
					<a
						href="https://s3-ap-southeast-1.amazonaws.com/kcloud.sms/sample_contact_import.csv"
						target="_blank"
						rel="noopener noreferrer"
						download
					>
						<Download height={24} width={24} color={'#1676EE'} />
						{t('BLD00336')}
					</a>
					<div className={Styles.attachementList}>
						<Attachment
							fileUrl={'abc.csv'}
							id={2}
							fileType={'csv'}
							fileName={'abc.csv'}
						/>
						<Attachment
							fileUrl={'abc.csv'}
							id={2}
							fileType={'csv'}
							fileName={'abc.csv'}
						/>
					</div>
				</div>
			);
		}
		return (
			<div className={Styles.copyContainer}>
				<TextArea
					// css={''}
					placeholder={
						'Enter or paste the mobile numbers to be seperated by new line'
					}
				/>
				<Checkbox label={t('BLD00344')} />
				<Select defaultValue={0} value={0} label={t('BLD00345')} />
			</div>
		);
	};

	const getFooter = (): React.ReactNode => {
		return (
			<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onClose}>
					{t('mainCancel')}
				</Button>
				<Button type="primary" onClick={onClose}>
					{t('mainImport')}
				</Button>
			</div>
		);
	};

	return (
		<Slider
			containerId="root-modal"
			onClose={onClose}
			visibility={true}
			footer={getFooter()}
			title={t('BLD00330')}
			tabs={[{
				label: t('BLD00331'),
				value: TabType.file
			}, {
				label: t('BLD00332'),
				value: TabType.copypaste
			}]}
			onTabClick={setTab}
		>
			<div className={Styles.container}>{getBody()}</div>
		</Slider>
	);
};

export default Import;
